module.exports = __webpack_public_path__ + "static/media/like-you-just-said.29cf389c.txt";